'use client'

import React, { useEffect, useRef, useState } from 'react'

import { FilterDisplayType } from '@/entities/catalog-brands'

import { Button } from '@/shared/ui'

import { useBrandFilter } from '../hooks/useBrandFilter'
import { getFilterUrlFromForm } from '../lib/get-filter-url-from-form'

import { AccordionFilter } from './accordion-filter/accordion-filter'
import { SwitchFilter } from './switch-filter/switch-filter'

import cls from './filter.module.scss'

export const Filter = (): JSX.Element => {
	const formRef = useRef<HTMLFormElement>(null)
	const [_formState, setFormState] = useState<string>('')

	const { properties, isLoading, onFilterChange, clearFilter, appliedFiltersCount, categoryCode } = useBrandFilter()

	// Расширенный обработчик изменений в форме
	const onChangeHandler = (): void => {
		if (formRef.current) {
			// Создаем объект фильтра с учетом кода категории
			const filterUrl = getFilterUrlFromForm(formRef.current)

			// Сохраняем текущее состояние формы для отслеживания изменений
			setFormState(filterUrl)

			// Отправляем данные фильтра
			onFilterChange?.(filterUrl)
		}
	}

	// Настраиваем скрытый инпут для кода категории
	useEffect(() => {
		if (formRef.current && categoryCode) {
			// Создаем скрытый инпут для кода категории
			const categoryInput = document.createElement('input')
			categoryInput.type = 'hidden'
			categoryInput.name = 'LIST_SECTION_CODE'
			categoryInput.value = categoryCode
			formRef.current.appendChild(categoryInput)
		}
	}, [categoryCode])

	return (
		<article className={cls.root}>
			<form
				ref={formRef}
				onChange={onChangeHandler}
				onSubmit={e => {
					e.preventDefault()
					return false
				}}>
				{properties?.map(({ ID, CODE, DISPLAY_TYPE, DISPLAY_EXPANDED, NAME, VALUES }) => (
					<>
						{DISPLAY_TYPE === FilterDisplayType.CheckBox && VALUES?.length > 1 && (
							<AccordionFilter
								key={ID}
								defaultOpen={!!DISPLAY_EXPANDED}
								name={NAME}
								code={CODE}
								items={VALUES}
								isDisabled={isLoading}
							/>
						)}
						{DISPLAY_TYPE === FilterDisplayType.Radio && (
							<SwitchFilter
								key={ID}
								label={NAME}
								name={CODE}
								checked={VALUES.some(value => value.CHECKED)}
								isDisabled={!VALUES[0].ELEMENT_COUNT || isLoading}
							/>
						)}
					</>
				))}
			</form>
			{!!appliedFiltersCount && (
				<Button onClick={clearFilter} theme="outlined" className={cls.clearButton}>
					Очистить фильтр
				</Button>
			)}
		</article>
	)
}
